<template>
  <div>
    <a-card size="small" :bordered="true" style="border: 1px solid #ccc; padding: 10px; border-radius: 4px;">
      <span style="margin-right: 8px">研发团队:</span>
      <a-checkable-tag :checked="selectedTeams.length === 0" @change="selectedTeams = []">全部</a-checkable-tag>
      <template v-for="team in teams">
        <a-checkable-tag :key="team.id" :checked="selectedTeams.indexOf(team.id) > -1" @change="checked => handleChange(team.id, checked)">
          {{ team.name }}
        </a-checkable-tag>
      </template>
    </a-card>
  </div>
</template>

<script>
import { teamList } from '@/api/system/team';

export default {
  name: 'TeamFilter',
  data() {
    return {
      teams: [],
      selectedTeams: []
    };
  },
  watch: {
    selectedTeams() {
      this.$emit('change', this.selectedTeams);
    }
  },
  created() {
    this.getTeamList();
    this.$emit('change', this.selectedTeams);
  },
  methods: {
    handleChange(team_id, checked) {
      const { selectedTeams } = this;
      const nextSelectedTeams = checked ? [...selectedTeams, team_id] : selectedTeams.filter(t => t !== team_id);
      this.selectedTeams = nextSelectedTeams;
    },
    // 获取团队列表
    getTeamList() {
      teamList({ category: 1 }).then(res => {
        this.teams = res.data.items;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0px;
  border-bottom: silver 1px dashed;
}
</style>
